/** The pattern that accepts every file: what a per-file binding needs to fire on all of them. */
export const ACCEPT_ALL_PATTERN = "**/*";
